module.exports = __webpack_public_path__ + "media/images/pic/anime/box-blog-type4-top-1d1ac1d62c6fe7c4442b2800e75ddb1f.svg";